import { useMutation } from '@tanstack/react-query';
import { GenQrBidvVAEntity, BidvVirtualAccountService, GenQrBidvVADto } from 'services/openapi';

export const useGenQrBidvVAMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<GenQrBidvVAEntity, Error, { endCode: string; requestBody: GenQrBidvVADto }>({
      mutationFn: (variables) => {
        return BidvVirtualAccountService.bidvVaControllerGenQr(variables.endCode, variables.requestBody);
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};